export interface Edges<T> {
  edges: T[];
}

export interface MapsOn<T, V> {
  mapsOn: T;
  node: V;
}

export enum ProductRelation {
  VARIANT = 'VARIANT',
  RELATED = 'RELATED',
  NEXT_EDITION = 'NEXT_EDITION',
  PRODUCT_SET_ITEM = 'PRODUCT_SET_ITEM',
}

export enum EditionFormat {
  DIGITAL = 'DIGITAL',
  DIGITAL_AND_PHYSICAL = 'DIGITAL_AND_PHYSICAL',
  PHYSICAL = 'PHYSICAL',
}

export enum PriceTypes {
  DISCOUNT = 'DISCOUNT',
  SUBTOTAL = 'SUBTOTAL',
  TOTAL = 'TOTAL',
  PRICE = 'PRICE',
  TAX = 'TAX',
}

export enum AdobeEventType {
  PAGE_VIEW = 'pageView',
  CART_VIEW = 'cartView',
  PROMO_CODE_SUCCESS = 'promoCodeSuccess',
  PROMO_CODE_FAILURE = 'promoCodeFailure',
  REMOVE_FROM_CART = 'removeFromCart',
  PROCEED_TO_CHECKOUT = 'proceedToCheckout',
  CLICK = 'click',
}

export interface SiteInfo {
  name: string;
  platform: 'web' | 'ios' | 'android';
  locale: string;
}

export interface PageInfo {
  pageName: string;
  section: string;
  subSection: string;
  subSubSection: string;
  pageCategory: string;
  pageLanguage: string;
  pageTemplate: string;
  pageBuild: string;
  pageNumber: string;
  breadcrumb: string;
}

export type AdobeDataLayerItem = AdobeDataLayerEvent | PageViewEvent | {
  ecommerce?: {
    currency?: string;
    products?: AdobeProduct | AdobeProduct[] | null;
  };
};

declare global {
  interface Window {
    adobeDataLayer: AdobeDataLayerItem[];
  }
}

export interface AdobeProduct {
  productName: string;
  productId: string;
  sku: string;
  category?: string;
  type: string;
  price?: string;
  quantity?: string;
  source: string;
}

export interface ComponentData {
  componentType: string;
  componentText: string;
  componentProductCode: string;
  componentPosition: string;
  linkURL: string;
  clickCategory: string;
  parentComponentType: string;
  parentComponentText: string;
}

export interface ErrorData {
  errorMessage: string;
}

export interface PageViewEvent {
  event: AdobeEventType.PAGE_VIEW;
  site: SiteInfo;
  page: PageInfo;
  user: UserInfo;
}

export interface UserInfo {
  loginStatus: string;
  loginType: string;
  adminType: string;
  almId: string;
  connectId: string;
}

export interface AdobeDataLayerEvent {
  event: string;
  promoCode?: string;
  error?: ErrorData;
  ecommerce?: {
    currency: string,
    products: AdobeProduct | AdobeProduct[];
  };
  component?: ComponentData;
}

export interface LicenseAgreementInfo {
  wplaiName: string;
  wplaiUrl: string;
}
